(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('event-collections', {
                parent: 'entity',
                url: '/event-collections',
                data: {
                    authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                    pageTitle: 'Event Collections'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/event-collections/event-collections.html',
                        controller: 'EventCollectionsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('event-collections-detail', {
                parent: 'entity',
                url: '/event-collections/{id}',
                data: {
                    authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                    pageTitle: 'Event Collections detail'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/event-collections/event-collections-detail.html',
                        controller: 'EventCollectionsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'event-collections',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('event-collections.delete', {
                parent: 'event-collections',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_PLAN_COORDINATOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-collections/event-collections-delete-dialog.html',
                        controller: 'EventCollectionsDeleteController',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function () {
                        $state.go('event-collections', null, {reload: 'event-collections'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('event-collections.egs', {
                parent: 'event-collections',
                url: '/egs',
                data: {
                    authorities: ['ROLE_PLAN_COORDINATOR']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-collections/egs-form.html',
                        controller: 'EgsFormController',
                        controllerAs: 'vm',
                        size: 'lg',
                        backdrop: 'static'
                    }).result.then(function () {
                        $state.go('event-collections', null, {reload: 'event-collections'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('egs-job-details', {
                parent: 'event-collections',
                url: '/egs/{id}',
                data: {
                    authorities: ['ROLE_PLAN_COORDINATOR'],
                    pageTitle: 'EGS Job detail'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-collections/egs-details.html',
                        controller: 'EgsDetailController',
                        controllerAs: 'vm',
                        size: 'lg',
                        backdrop: 'static'
                    }).result.then(function () {
                        $state.go('event-collections', null, {reload: 'event-collections'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }

})();
